export type AccessLevel = "any" | "not_guest" | "premium";

/**
 * Any: Any user can access the action
 * Not guest: Any user can access the action except guest users
 * Premium: Only premium users can access the action
 */

export const ACTION_GUARDS: Record<string, AccessLevel> = {
  edit_profile: "not_guest",
  generate_post: "premium",
  send_message: "premium",
  open_calification_modal: "premium",
  upgrade_plan: "not_guest",
  new_material_budget: "premium",
  open_work_offer: "premium",
  apply_to_offer: "not_guest",
  open_feed_modal: "premium",
  download_pdf: "premium",
  filter_work_bag: "premium",
  open_post_modal: "premium",
  quote_project: "premium",
  create_project: "premium",
  send_quotation: "premium",
  view_profile: "premium",
  contact_profile: "premium",
  like_post: "not_guest",
  like_post_comment: "not_guest",
  response_post_comment: "not_guest",
  create_work_offer: "premium",
  view_work_offer: "premium",
  open_publication_modal: "premium",
  send_calification: "not_guest",
  create_post: "premium",
  create_product: "not_guest",
};
